import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Content from './contentComponent';
import LoginComponent from '../components/authentications/Login/Login'; 
import * as staticConfigs from '../utilities/staticConfigs'; 
import { LoadingProvider } from "./loadingContext";
import Loading from "../components/commons/loading";
import ForgotPassword from "../components/authentications/ForgotPassword/ForgotPassword";
import ForgotPasswordChangeForm from "../components/authentications/ForgotPassword/ForgotPasswordChange";
import ForceResetPassword from "../components/authentications/ForcePasswordReset/ForcePasswordReset";
import { ViewReceipts } from "../components/Payments/PaymentModule/viewReceipts";
import GlobalNotification from "../components/commons/GlobalNotification";

import { useSelector, useDispatch } from 'react-redux';

const ScrollToTopOnRouteChange = () => {
    const location = useLocation();

    useEffect(() => {
        if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Let the new route paint before resetting scroll.
        requestAnimationFrame(() => {
            // Reset window scroll.
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

            // Reset scroll for common scroll containers if present.
            const mainEl = document.querySelector('main');
            if (mainEl && typeof mainEl.scrollTo === 'function') {
                mainEl.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            }
        });
    }, [location.pathname]);

    return null;
};

// This component handles the actual navigation logic
const NavigationWatcher = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const shouldRedirect = useSelector((state) => state.commonStates.shouldRedirectToLogin);

    useEffect(() => {
        if (shouldRedirect) {
            // Move to login page without page reload
            history.push('/');

            // Reset the flag so it doesn't loop
            dispatch({ 
                type: "commonStates/setCommonState", 
                payload: { name: "shouldRedirectToLogin", value: false } 
            });
        }
    }, [shouldRedirect, history, dispatch]);

    return null; // This component doesn't render anything
};

const Router = () => {
    const [showLoadingBar, setShowLoadingBar] = useState(false);

    return (
        <BrowserRouter>
        <GlobalNotification />

        <ScrollToTopOnRouteChange />

        {/* The watcher must be INSIDE BrowserRouter to access 'history' */}
        <NavigationWatcher />
        
        <Content />           

        <Switch>    
            <LoadingProvider value={setShowLoadingBar}>    
                <Loading showLoadingBar={showLoadingBar} />    
                <Route path='/' exact={true} component={LoginComponent} />
                <Route exact path={staticConfigs.LOGIN_ROUTE_SUPER} component={LoginComponent} />
                <Route exact path={staticConfigs.LOGIN_ROUTE_SUPER+'/'} component={LoginComponent} />
                {/* <Route exact path={staticConfigs.ROUTE_RESET_PASSWORD} component={ResetPasswordComponent} />
                <Route exact path={staticConfigs.ROUTE_VERIFY_EMAIL} component={EmailVerificationComponent} /> */}
                <Route exact path={staticConfigs.ROUTE_FORGOT_SEND_MAIL} component={ForgotPassword} />
                <Route exact path={staticConfigs.ROUTE_FORGOT_PASSWORD} component={ForgotPasswordChangeForm} />
                <Route exact path={staticConfigs.ROUTE_FORCE_RESET_PASSWORD} component={ForceResetPassword} />
                <Route exact path={staticConfigs.ROUTE_VIEW_RECEIPTS} component={ViewReceipts} />
            </LoadingProvider>  
        </Switch>


        </BrowserRouter>
    )
}

export default Router;